import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, PreloadAllModules, Routes } from '@angular/router';

const appRoutes: Routes = [	
	{
		path: 'datos-basicos',
		loadChildren: () => import('./main/datos-basicos/datos-basicos.module').then(m => m.DatosBasicosModule)
	},	
	{
		path: 'document-editor',
		loadChildren: () => import('./main/document-editor/document-editor.module').then(m => m.DocumentEditorModule)
	},	
	{
		path: 'recursos-humanos',
		loadChildren: () => import('./main/recursos-humanos/recursos-humanos.module').then(m => m.RecursosHumanosModule)
	},
	{
		path: 'contratos',
		loadChildren: () => import('./main/contratos/contratos.module').then(m => m.ContratosModule)
	},
	{
		path: 'contratos/jefe-dependencia',
		loadChildren: () => import('./main/jefe-dependencia/jefe-dependencia.module').then(m => m.JefeDependenciaModule)
	},
	{
		path: 'contratista',
		loadChildren: () => import('./main/contratista/contratista.module').then(m => m.ContratistaModule)
	},
	{
		path: 'supervision',
		loadChildren: () => import('./main/supervisor/supervisor.module').then(m => m.SupervisorModule)
	},
	{
		path: 'contabilidad',
		loadChildren: () => import('./main/contabilidad/contabilidad.module').then(m => m.ContabilidadModule)
	},
	{
		path: 'interventoria',
		loadChildren: () => import('./main/interventoria/interventoria.module').then(m => m.InterventoriaModule)
	},
	{
		path: 'reportes',
		loadChildren: () => import('./main/reportes/reportes.module').then(m => m.ReportesModule)
	},
	{
		path: 'solicitud-contrato',
		loadChildren: () => import('./main/estudios-previos/estudios-previos.module').then(m => m.EstudiosPreviosModule)
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./main/dashboard/dashboard.module').then(m => m.DashboardModule)
	},
	{
		path: 'presupuesto',
		loadChildren: () => import('./main/presupuesto/presupuesto.module').then(m => m.PresupuestoModule)
	},
	{
		path: 'verificador-de-documentos',
		loadChildren: () => import('./main/verificador-documentos/verificador-documentos.module').then(m => m.VerificadorDocumentosModule)
	},
	{
		path: '**',
		redirectTo: 'home'
	}
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules})
  ]
})
export class AppRoutingModule { }
